import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody } from "@chakra-ui/react";
import ProductAnalytics from "./ProductAnalytics";

const ProductAnalyticsModal = ({ isOpen, onClose, product }) => {
  return (
    <Modal isOpen={isOpen} size="5xl" onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p={0}>
          {product && (
            <ProductAnalytics
              initialProduct={product}
              fixedProduct={true}
              hideProductSelect={true}
              autoFetchOnMount={true}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ProductAnalyticsModal;
